import IAjax from './ajax.type';
import ILog from './log.type';
import IPD from './pd.type';
import IPerformance from './performance.type';
import IPV from './pv.type';
import IResource from './resource.type';

export interface IRegion {
    lng: string;        // longitude
    lat: string;        // latitude
}

export enum BridgeType {
    NONE = 'NONE',
}

export interface IBridge {
    type: BridgeType;
}

export interface IUA {
    ua: string;	            // us string
    browser: string;        // 浏览器信息
    os: string;	            // 操作系统
    device?: string;        // 设备信息
    platform?: string;      // 平台
}

export interface INetwork {
    online?: boolean;       // [OPTIONAL] 是否在线
    isp?: string;           // [OPTIONAL] 网络供应商信息
    connection?: string;    // [OPTIONAL] 网络类型
}

// 公共数据，页面加载只获取一次
export interface IShared {
    env: string;            // 开发环境信息
    project: string;        // 项目名称
    autopv: boolean;          // 是否是自动打点(默认false，true给无埋点用)
    unionId: string;        // 用户ID，用户的唯一id
    version: string;        // sdk版本
    screen: string;         // 屏幕尺寸
    userAgent: IUA;		    // ua信息
    jsBridge?: IBridge;	    // JS bridge 信息(Hybrid 应用)
}

// 公共数据，页面加载只获取一次字段
export const sharedAttrs = [
    'env',
    'project',
    'autopv',
    'unionId',
    'version',
    'screen',
    'userAgent',
    // 'jsBridge',
    'localStorage',
];

// 暂时没用的不上报字段
export const ignoreAttrs = ['jsBridge', 'region'];

export default interface IMessage {
    // runtime
    "@timestamp"?: string;       // ES所需要的 UTC timestamp
    duration?: number;           // 日志发送距页面打开时间
    // not in resource
    category?: string;           // 日志类别
    pageId?: string;             // 当前设置的页面Id
    pageUrl?: string;            // 当前页面的url
    region?: IRegion;			 // 用户地理信息
    network?: INetwork;			 // 网络情况
    // optional
    businessInfo?: object;      // 业务信息
    channel?: string;           // 渠道
    localStorage?: object;      // localStorage信息
    // middleware
    pv?: IPV;					 // PV信息
    performance?: IPerformance;	 // 页面性能数据信息
    pd?: IPD;                    // PD信息
    xhr?: IAjax;			     // 网络ajax请求信息
    resource?: IResource;		 // 网络资源请求信息
    log?: ILog;					 // jsError/report/moduleClick/moduleView/moduleEdit
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/core/types/message.type.ts